'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
var OrderedList = function OrderedList(props) {
  return _react2.default.createElement(
    _Icon2.default,
    _extends({ viewBox: '0 0 30 30' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M8 21h2l-1 1 1 1H8v1h3v-1l-1-1 1-1v-1H8v1zm0-6h2.1L8 17v1h3v-1H9.1l1.9-2v-1H8v1zm1-3h1V8H8v1h1v3zm4-1h10V9H13v2zm0 6h10v-2H13v2zm0 6h10v-2H13v2z' })
    )
  );
};
/*eslint-enable */

exports.default = OrderedList;
//# sourceMappingURL=OrderedList.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/src/Icons/dist/components/OrderedList.js